import React, { useEffect, useState } from 'react';
import PokemonImageVs from './PokemonImageVs';
import './Versus.css';
import { Redirect } from 'react-router-dom';


const Versus = props => {

  const [pokemonOpponent, setPokemonOpponent] = useState(props.pokemons[Math.floor(Math.random() * props.pokemons.length)]);

  useEffect(() => {
    props.setOpponents([props.name, pokemonOpponent.name])
  }, [pokemonOpponent])
  
  const [redirection, setRedirection] = useState(null);

  setTimeout(() => {
    redirectToFight()
  }, 5000);

  const redirectToFight = () => setRedirection(<Redirect to='./Fight' />)
  
  return (
    <div className="Versus">
      {redirection}
      <PokemonImageVs name={props.name}/>
      <div className="vs">VS</div>
      <PokemonImageVs name={pokemonOpponent.name} />
  </div>
  );
}

export default Versus;